/* Nexora theme — cart drawer, add to cart, quantity, gallery, Player Lab quiz, sticky bar, exit intent, reveal. */
(function () {
  'use strict';

  var NX = window.NX || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // Shopify escapes translations that take variables (YOU&#39;RE), so decode them before the JS re-escapes its output.
  var decoder = document.createElement('textarea');
  function decode(s) { decoder.innerHTML = s; return decoder.value; }

  function str(key, vars) {
    var s = decode((NX.strings && NX.strings[key]) || '');
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('__' + k.toUpperCase() + '__').join(vars[k]); });
    return s;
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function icon(name, cls) {
    var tpl = document.getElementById('nx-icon-' + name);
    if (!tpl) return '';
    var html = tpl.innerHTML.trim();
    return cls ? html.replace('class="nx-icon', 'class="nx-icon ' + cls) : html;
  }

  /* ---------- Money ---------- */
  function delimit(num, thousands, decimal) {
    var parts = num.split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents) {
    var format = NX.moneyFormat || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(re);
    var type = match ? match[1] : 'amount';
    var value = (Number(cents) || 0) / 100;
    var out;
    switch (type) {
      case 'amount_no_decimals': out = delimit(Math.round(value).toString(), ',', '.'); break;
      case 'amount_with_comma_separator': out = delimit(value.toFixed(2), '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delimit(Math.round(value).toString(), '.', ','); break;
      case 'amount_with_space_separator': out = delimit(value.toFixed(2), ' ', ','); break;
      case 'amount_with_apostrophe_separator': out = delimit(value.toFixed(2), "'", '.'); break;
      default: out = delimit(value.toFixed(2), ',', '.');
    }
    return format.replace(re, out);
  }
  NX.money = money;

  /* ---------- Cart API ---------- */
  var routes = NX.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', collections: '/collections/all' };

  function request(url, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  var Cart = {
    data: null,
    get: function () { return request(routes.cart + '.js').then(function (c) { Cart.data = c; return c; }); },
    add: function (items) { return request(routes.cartAdd + '.js', { items: items }); },
    change: function (line, quantity) { return request(routes.cartChange + '.js', { line: line, quantity: quantity }).then(function (c) { Cart.data = c; return c; }); }
  };
  NX.cart = Cart;

  /* ---------- Shipping progress ---------- */
  function renderShipping(el, cents) {
    if (!el) return;
    var threshold = (NX.freeShipping || 35) * 100;
    var remaining = Math.max(0, threshold - cents);
    var unlocked = remaining === 0;
    var pct = Math.min(100, (cents / threshold) * 100);
    var msg = $('[data-ship-msg]', el);
    var fill = $('[data-ship-fill]', el);
    if (msg) {
      msg.classList.toggle('is-unlocked', unlocked);
      msg.innerHTML = unlocked ? esc(str('freeUnlocked')) : esc(str('freeAway')).replace('__AMOUNT__', '<b>' + esc(money(remaining)) + '</b>');
    }
    if (fill) {
      fill.style.width = pct + '%';
      fill.classList.toggle('is-unlocked', unlocked);
    }
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast() {
    var el = $('[data-nx-toast]');
    if (!el) return;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2500);
  }

  /* ---------- Keyboard focus for the drawer and modals ---------- */
  // Tab stays inside the open panel, and focus goes back to the button that opened it.
  var lastFocus = null;

  function focusables(root) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function focusPanel(panel, target) {
    if (!lastFocus || !panel.contains(lastFocus)) lastFocus = document.activeElement;
    var el = target || focusables(panel)[0];
    el && el.focus({ preventScroll: true });
  }

  function restoreFocus() {
    if (lastFocus && document.contains(lastFocus) && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var panel = $('[data-nx-drawer].is-open') || $('[data-nx-lab].is-open') || $('[data-nx-exit].is-open');
    if (!panel) return;
    var els = focusables(panel);
    if (!els.length) return;
    var first = els[0];
    var last = els[els.length - 1];
    if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-nx-drawer]');
  var overlay = $('[data-nx-drawer-overlay]');

  function openDrawer() {
    if (!drawer) { window.location.href = routes.cart; return; }
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    focusPanel(drawer, $('[data-nx-drawer-close]', drawer));
  }

  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    restoreFocus();
  }
  NX.openCart = openDrawer;

  function productByHandle(handle) {
    var products = NX.products || {};
    for (var key in products) if (products[key] && products[key].handle === handle) return products[key];
    return null;
  }

  function upsellHtml(cart) {
    var p = NX.products || {};
    var handles = cart.items.map(function (i) { return i.handle; });
    var has = function (prod) { return prod && handles.indexOf(prod.handle) !== -1; };
    var subtotal = cart.total_price;
    var pulsePackOffer = p.pulsepack && p.pulsepack.available && has(p.pulse) && !has(p.pulsepack) && !has(p.ultimate) && subtotal < (NX.freeShipping || 35) * 100;
    var hasOther = cart.items.some(function (i) { return !p.ultimate || i.handle !== p.ultimate.handle; });
    var ultimateOffer = p.ultimate && p.ultimate.available && hasOther && !has(p.ultimate) && !pulsePackOffer;
    if (pulsePackOffer) {
      var saveP = p.pulse ? p.pulse.price * 2 - p.pulsepack.price : 0;
      return '<div class="nx-upsell"><p class="nx-eyebrow">' + esc(str('smartBundle')) + '</p>' +
        '<p class="nx-upsell__body">' + esc(str('smartBundleBody')).replace('__AMOUNT__', esc(money(saveP))) + '</p>' +
        (saveP > 0 ? '<span class="nx-badge">' + esc(str('save')).replace('__AMOUNT__', esc(money(saveP))) + '</span>' : '') +
        '<button type="button" data-nx-add="' + p.pulsepack.variantId + '">' + esc(str('getPulse')) + '</button></div>';
    }
    if (ultimateOffer) {
      var individual = ['pulse', 'obsidian', 'phantom'].reduce(function (s, k) { return s + (p[k] ? p[k].price : 0); }, 0);
      var saveU = individual - p.ultimate.price;
      return '<div class="nx-upsell"><p class="nx-eyebrow">' + esc(str('completeSetup')) + '</p>' +
        '<p class="nx-upsell__body">' + esc(str('completeSetupBody')).replace('__AMOUNT__', esc(money(p.ultimate.price))) + '</p>' +
        (saveU > 0 ? '<span class="nx-badge">' + esc(str('save')).replace('__AMOUNT__', esc(money(saveU))) + '</span>' : '') +
        '<button type="button" data-nx-add="' + p.ultimate.variantId + '">' + esc(str('getUltimate')) + '</button></div>';
    }
    return '';
  }

  function renderCart(cart) {
    $$('[data-nx-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    $('[data-nx-drawer-count]', drawer).textContent = cart.item_count;
    renderShipping($('[data-nx-drawer-ship]', drawer), cart.total_price);
    var items = $('[data-nx-drawer-items]', drawer);
    var foot = $('[data-nx-drawer-foot]', drawer);
    var upsell = $('[data-nx-drawer-upsell]', drawer);
    if (!cart.item_count) {
      items.innerHTML = '<div class="nx-drawer__empty">' + icon('bag') + '<strong>' + esc(str('empty')) + '</strong><p>' + esc(str('emptyBody')) + '</p>' +
        '<a href="' + esc(routes.collections) + '">' + esc(str('shop')) + '</a></div>';
      upsell.innerHTML = '';
      foot.hidden = true;
      return;
    }
    items.innerHTML = cart.items.map(function (item, index) {
      var img = item.image || '';
      var imgUrl = img ? img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=160' : '';
      return '<div class="nx-line">' +
        (imgUrl ? '<img class="nx-line__img" src="' + esc(imgUrl) + '" alt="' + esc(item.product_title) + '" width="80" height="80" loading="lazy">' : '<div class="nx-line__img"></div>') +
        '<div class="nx-line__info"><div class="nx-line__top"><a class="nx-line__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        '<button type="button" class="nx-line__remove" data-nx-line="' + (index + 1) + '" data-nx-qty-set="0">' + esc(str('remove')) + '</button></div>' +
        '<p class="nx-line__price">' + esc(money(item.final_price)) + ' <span class="nx-currency">' + esc(NX.currency || '') + '</span></p>' +
        '<div class="nx-qty"><button type="button" aria-label="-" data-nx-line="' + (index + 1) + '" data-nx-qty-set="' + (item.quantity - 1) + '">' + icon('minus', 'nx-icon--xs') + '</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" aria-label="+" data-nx-line="' + (index + 1) + '" data-nx-qty-set="' + (item.quantity + 1) + '">' + icon('plus', 'nx-icon--xs') + '</button></div>' +
        '</div></div>';
    }).join('');
    upsell.innerHTML = upsellHtml(cart);
    foot.hidden = false;
    $('[data-nx-drawer-subtotal]', drawer).textContent = money(cart.total_price) + ' ' + (NX.currency || '');
  }

  function refreshCart() { return Cart.get().then(renderCart).catch(function () {}); }

  function addToCart(variantId, quantity, opts) {
    opts = opts || {};
    return Cart.add([{ id: Number(variantId), quantity: quantity || 1 }])
      .then(function () { return Cart.get(); })
      .then(function (cart) {
        renderCart(cart);
        toast();
        if (opts.open) setTimeout(openDrawer, opts.delay || 0);
        return cart;
      })
      .catch(function (err) {
        window.alert(str('error') + (err && err.message ? '\n' + err.message : ''));
      });
  }
  NX.addToCart = addToCart;

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-nx-cart-open]');
    if (openBtn && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-nx-drawer-close]') || e.target.closest('[data-nx-drawer-overlay]')) { closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-nx-qty-set]');
    if (qtyBtn && qtyBtn.hasAttribute('data-nx-line')) {
      e.preventDefault();
      drawer && drawer.classList.add('is-busy');
      Cart.change(Number(qtyBtn.getAttribute('data-nx-line')), Math.max(0, Number(qtyBtn.getAttribute('data-nx-qty-set'))))
        .then(renderCart)
        .catch(function () { window.alert(str('error')); })
        .then(function () { drawer && drawer.classList.remove('is-busy'); });
      return;
    }

    var addBtn = e.target.closest('[data-nx-add]');
    if (addBtn) {
      e.preventDefault();
      var id = addBtn.getAttribute('data-nx-add');
      if (!id) return;
      addBtn.classList.add('is-disabled');
      addToCart(id, 1, { open: addBtn.hasAttribute('data-nx-open-cart'), delay: 300 }).then(function () { addBtn.classList.remove('is-disabled'); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeLab();
    closeExit();
    if (mobileNav && mobileNav.classList.contains('is-open')) { closeMenu(); menuToggle.focus(); }
  });

  /* ---------- Header mobile menu ---------- */
  var menuToggle = $('[data-nx-menu-toggle]');
  var mobileNav = $('[data-nx-mobile-nav]');
  function closeMenu() {
    mobileNav.classList.remove('is-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.innerHTML = icon('menu', 'nx-icon--md');
  }
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuToggle.innerHTML = open ? icon('x', 'nx-icon--md') : icon('menu', 'nx-icon--md');
    });
    $$('a', mobileNav).forEach(function (a) { a.addEventListener('click', closeMenu); });
  }

  /* ---------- Product page ---------- */
  $$('[data-nx-product]').forEach(function (root) {
    var form = $('form[data-nx-product-form]', root);
    var qtyInput = $('[data-nx-qty-input]', root);
    var qtyLabel = $('[data-nx-qty-label]', root);
    var totalEl = $('[data-nx-total]', root);
    var nxpEl = $('[data-nx-nxp]', root);
    var price = Number(root.getAttribute('data-price')) || 0;
    var ppd = Number(NX.pointsPerDollar) || 10;

    function setQty(q) {
      q = Math.max(1, q);
      if (qtyInput) qtyInput.value = q;
      if (qtyLabel) qtyLabel.textContent = q;
      if (totalEl) totalEl.textContent = money(price * q) + ' ' + (NX.currency || '');
      if (nxpEl) nxpEl.textContent = str('earnNxp').replace('__NXP__', Math.floor((price * q / 100) * ppd).toLocaleString());
      renderShipping($('[data-nx-pdp-ship]', root), price * q);
    }

    $$('[data-nx-step]', root).forEach(function (btn) {
      btn.addEventListener('click', function () { setQty((Number(qtyInput && qtyInput.value) || 1) + Number(btn.getAttribute('data-nx-step'))); });
    });
    setQty(Number(qtyInput && qtyInput.value) || 1);

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[type="submit"]', form);
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.textContent = str('adding'); }
        addToCart($('[name="id"]', form).value, Number(qtyInput && qtyInput.value) || 1).then(function (cart) {
          if (!btn) return;
          btn.innerHTML = icon('check', 'nx-icon--sm') + ' ' + esc(str('added'));
          setTimeout(function () { btn.disabled = false; btn.innerHTML = label; if (cart) openDrawer(); }, 600);
        });
      });
    }

    var main = $('.nx-gallery__main img', root);
    $$('[data-nx-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        $$('[data-nx-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  });

  /* Sticky mobile add-to-cart bar */
  var sticky = $('[data-nx-sticky]');
  if (sticky) {
    var dismissed = false;
    var onScroll = function () { if (!dismissed) sticky.classList.toggle('is-visible', window.scrollY > 600); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var dismiss = $('[data-nx-sticky-dismiss]', sticky);
    dismiss && dismiss.addEventListener('click', function () { dismissed = true; sticky.classList.remove('is-visible'); });
  }

  /* ---------- Player Lab ---------- */
  var labModal = $('[data-nx-lab]');
  var labData = null;
  var lab = { step: 0, answers: {} };

  function closeLab() {
    if (!labModal || !labModal.classList.contains('is-open')) return;
    labModal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    restoreFocus();
  }

  // Each quiz step replaces the buttons, so put focus back on the step instead of losing it.
  function keepLabFocus() {
    if (labModal.contains(document.activeElement) && document.activeElement !== document.body) return;
    var el = $('.nx-quiz__option.is-selected', labModal) || $('[data-lab-option]', labModal) || focusables($('[data-nx-lab-body]', labModal))[0];
    el && el.focus({ preventScroll: true });
  }

  function labRecommend(answers) {
    var scores = { pulse: 0, phantom: 0, obsidian: 0, ultimate: 0 };
    var interests = {};
    labData.questions.forEach(function (q) {
      var opt = q.options.filter(function (o) { return o.id === answers[q.id]; })[0];
      if (!opt || !opt.scores) return;
      Object.keys(opt.scores).forEach(function (p) { scores[p] += opt.scores[p]; interests[p] = true; });
    });
    if (Object.keys(interests).length >= 3) scores.ultimate += 1;
    var sorted = Object.keys(scores).map(function (k) { return [k, scores[k]]; }).sort(function (a, b) { return b[1] - a[1]; });
    var primary = sorted[0][0];
    if (sorted[0][1] === sorted[1][1]) {
      var pref = { full_setup: 'ultimate', first_pair: 'pulse', try_different: 'obsidian', upgrade: 'phantom' }[answers.looking_for];
      if (pref && scores[pref] === sorted[0][1]) primary = pref;
    }
    var secondary = (sorted.filter(function (s) { return s[0] !== primary; })[0] || sorted[1])[0];
    return { primary: primary, secondary: secondary };
  }

  function labRender() {
    var body = $('[data-nx-lab-body]', labModal);
    var s = labData.strings;
    var total = labData.questions.length;
    if (lab.step < total) {
      var q = labData.questions[lab.step];
      var selected = lab.answers[q.id];
      body.innerHTML = '<div class="nx-quiz">' +
        '<div class="nx-quiz__top"><span class="nx-quiz__step">' + ('0' + (lab.step + 1)).slice(-2) + ' / ' + ('0' + total).slice(-2) + '</span>' +
        '<button type="button" class="nx-quiz__restart" data-lab-restart>' + icon('rotate', 'nx-icon--xs') + ' ' + esc(s.restart) + '</button></div>' +
        '<div class="nx-quiz__bar"><div class="nx-quiz__fill" style="width:' + ((lab.step + 1) / total * 100) + '%"></div></div>' +
        '<h2 class="nx-quiz__q">' + esc(q.title) + '</h2>' +
        '<div class="nx-quiz__options" role="radiogroup">' + q.options.map(function (o) {
          var on = selected === o.id;
          return '<button type="button" role="radio" aria-checked="' + on + '" class="nx-quiz__option' + (on ? ' is-selected' : '') + '" data-lab-option="' + esc(o.id) + '">' +
            '<span class="nx-quiz__option-top">' + esc(o.label) + icon('check', 'nx-icon--sm') + '</span>' +
            (o.desc ? '<span class="nx-quiz__option-desc" style="display:block">' + esc(o.desc) + '</span>' : '') + '</button>';
        }).join('') + '</div>' +
        '<div class="nx-quiz__nav"><button type="button" class="nx-quiz__back" data-lab-back' + (lab.step === 0 ? ' disabled' : '') + '>' + icon('arrow-left', 'nx-icon--sm') + ' ' + esc(s.back) + '</button>' +
        '<button type="button" class="nx-btn nx-btn--primary nx-btn--sm nx-quiz__next" data-lab-next' + (selected ? '' : ' disabled') + '>' + esc(s.next) + ' ' + icon('arrow-right', 'nx-icon--sm') + '</button></div></div>';
      return;
    }
    if (lab.step === total) {
      body.innerHTML = '<div class="nx-quiz__analyzing">' + esc(s.analyzing) + '</div>';
      setTimeout(function () { lab.result = labRecommend(lab.answers); lab.step = total + 1; labRender(); keepLabFocus(); }, 1500);
      return;
    }
    var r = lab.result;
    var prod = labData.products[r.primary];
    var alt = labData.products[r.secondary];
    var copy = labData.results[r.primary];
    if (!prod) { body.innerHTML = ''; return; }
    var upsell = '';
    if (r.primary === 'pulse' && labData.products.pulsepack) {
      var pp = labData.products.pulsepack;
      upsell = '<div class="nx-result__upsell"><div><p class="nx-eyebrow">' + esc(s.want_more) + '</p><p style="margin-top:12px" class="nx-card__title">PULSE PACK</p><p class="nx-mono-note" style="margin-top:4px">2× PulseSleeves · ' + esc(pp.priceText) + '</p></div>' +
        '<button type="button" class="nx-btn nx-btn--primary nx-btn--sm" data-nx-add="' + pp.variantId + '">' + esc(s.get_pack) + '</button></div>';
    } else if (lab.answers.looking_for === 'full_setup' && r.primary !== 'ultimate' && labData.products.ultimate) {
      var up = labData.products.ultimate;
      upsell = '<div class="nx-result__upsell"><div><p class="nx-eyebrow">' + esc(s.want_more) + '</p><p style="margin-top:12px" class="nx-card__title">ULTIMATE PACK</p><p class="nx-mono-note" style="margin-top:4px">Pulse + Obsidian + Phantom · ' + esc(up.priceText) + '</p></div>' +
        '<button type="button" class="nx-btn nx-btn--primary nx-btn--sm" data-nx-add="' + up.variantId + '">' + esc(s.get_ultimate) + '</button></div>';
    }
    body.innerHTML = '<div class="nx-quiz"><div class="nx-center"><span class="nx-tag">' + esc(s.your_match) + '</span>' +
      '<h2 class="nx-result__name">' + esc(prod.title) + '</h2><p class="nx-result__tagline">' + esc(copy.tagline) + '</p></div>' +
      '<div class="nx-result__grid"><div class="nx-media nx-media--square nx-media--bordered">' + (prod.image ? '<img src="' + esc(prod.image) + '" alt="' + esc(prod.title) + '" loading="lazy">' : '') + '</div>' +
      '<div><p class="nx-result__text">' + esc(copy.text) + '</p><p class="nx-result__price">' + esc(prod.priceText) + '</p>' +
      '<div class="nx-btn-row" style="margin-top:24px"><a class="nx-btn nx-btn--primary nx-btn--sm" href="' + esc(prod.url) + '">' + esc(s.shop_now) + ' ' + icon('arrow-right', 'nx-icon--sm') + '</a>' +
      '<a class="nx-btn nx-btn--secondary nx-btn--sm" href="' + esc(routes.collections) + '">' + esc(s.see_all) + '</a></div></div></div>' +
      (alt ? '<div class="nx-result__more"><p class="nx-mono-note">' + esc(s.explore_more) + '</p><a class="nx-result__alt" href="' + esc(alt.url) + '"><span><span class="nx-card__title" style="display:block;font-size:14px">' + esc(alt.title) + '</span><span class="nx-muted" style="display:block;margin-top:4px;font-size:12px">' + esc(alt.priceText) + '</span></span>' + icon('arrow-right', 'nx-icon--sm') + '</a></div>' : '') +
      upsell +
      '<div class="nx-result__more"><button type="button" class="nx-quiz__restart" data-lab-restart>' + icon('rotate', 'nx-icon--xs') + ' ' + esc(s.retake) + '</button></div></div>';
  }

  if (labModal) {
    var dataEl = document.getElementById('nx-lab-data');
    try { labData = JSON.parse(dataEl.textContent); } catch (err) { labData = null; }
    // The quiz copy comes from translations, which Shopify HTML-escapes (&amp;, &#39;), so decode it once here.
    var decodeAll = function (o) {
      if (typeof o === 'string') return decode(o);
      if (o && typeof o === 'object') Object.keys(o).forEach(function (k) { o[k] = decodeAll(o[k]); });
      return o;
    };
    if (labData) ['strings', 'questions', 'results'].forEach(function (k) { labData[k] = decodeAll(labData[k]); });
    $$('[data-nx-lab-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!labData) return;
        e.preventDefault();
        lab = { step: 0, answers: {} };
        labModal.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        labRender();
        focusPanel(labModal, $('[data-nx-lab-close]', labModal));
      });
    });
    labModal.addEventListener('click', function (e) {
      if (e.target === labModal || e.target.closest('[data-nx-lab-close]')) { closeLab(); return; }
      var opt = e.target.closest('[data-lab-option]');
      if (opt) { lab.answers[labData.questions[lab.step].id] = opt.getAttribute('data-lab-option'); labRender(); keepLabFocus(); return; }
      if (e.target.closest('[data-lab-next]')) { lab.step += 1; labRender(); keepLabFocus(); return; }
      if (e.target.closest('[data-lab-back]')) { lab.step = Math.max(0, lab.step - 1); labRender(); keepLabFocus(); return; }
      if (e.target.closest('[data-lab-restart]')) { lab = { step: 0, answers: {} }; labRender(); keepLabFocus(); }
    });
  }

  /* ---------- Exit intent ---------- */
  var exitModal = $('[data-nx-exit]');
  function closeExit() {
    if (!exitModal || !exitModal.classList.contains('is-open')) return;
    exitModal.classList.remove('is-open');
    restoreFocus();
  }
  if (exitModal && window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 0) return;
      var count = Cart.data ? Cart.data.item_count : Number(($('[data-nx-cart-count]') || {}).textContent || 0);
      if (!count) return;
      try { if (sessionStorage.getItem('nx-exit-shown')) return; sessionStorage.setItem('nx-exit-shown', '1'); } catch (err) { /* storage blocked */ }
      exitModal.classList.add('is-open');
      focusPanel(exitModal, $('[data-nx-exit-close]', exitModal));
    });
    exitModal.addEventListener('click', function (e) {
      if (e.target === exitModal || e.target.closest('[data-nx-exit-close]')) { closeExit(); return; }
      if (e.target.closest('[data-nx-exit-cart]')) { closeExit(); openDrawer(); }
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var revealEls = $$('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var delay = entry.target.getAttribute('data-reveal-delay');
        if (delay) entry.target.style.transitionDelay = delay + 's';
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: .05 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }
  var hero = $('.nx-hero');
  hero && hero.classList.add('is-loaded');

  /* Initial cart state */
  if (Cart.data === null && NX.initialCart) { Cart.data = NX.initialCart; }
  if (drawer && NX.initialCart) renderCart(NX.initialCart);

  document.addEventListener('shopify:section:load', function () { if (Cart.data) renderCart(Cart.data); });
})();
